import { Helmet } from "react-helmet-async";

const SITE_URL = process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "");
const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1584598416417-84bd357908ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE, jsonLd }) => {
  const url = `${SITE_URL}${path}`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="DronAcademy" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
};

export { SITE_URL };
